import {
  AnalysisProseCard,
  AnalysisSubHeader,
  SectionSeparator,
  TwoColumnProse,
} from '../../../../components';
import { StatistaChartCard } from '../StatistaCharts';

import type { CompetitiveLandscapeAndMarketGrowthProps } from './CompetitiveLandscapeAndMarketGrowth.types';
import { useTranslation } from 'react-i18next';

export const CompetitiveLandscapeAndMarketGrowth = ({
  overview,
  overviewQuote,
  marketSize,
  landscapeDatasets,
  marketGrowthDatasets,
}: CompetitiveLandscapeAndMarketGrowthProps) => {
  const { t } = useTranslation('analysis');

  const yoyTrends = marketSize?.yoyTrends;
  // Prose alone decides: a chart is matched from the prose that cites it, so there is no
  // charts-without-prose case to guard for.
  const hasOverview = !!overview;
  const hasMarketGrowth = !!yoyTrends;

  if (!hasOverview && !hasMarketGrowth) return null;

  return (
    <div className="flex flex-col gap-16">
      {hasOverview && (
        <div className="flex flex-col gap-6">
          <AnalysisProseCard
            title={t(
              'analysisResult.competitiveLandscapeAndMarketGrowth.competitiveLandscapeOverview',
            )}
            quote={overviewQuote}
            description={overview}
            columns={2}
          />
          {landscapeDatasets?.map((cited) => (
            <StatistaChartCard key={cited.id} dataset={cited} citedIn={overview} />
          ))}
        </div>
      )}

      {hasOverview && hasMarketGrowth && <SectionSeparator />}

      {hasMarketGrowth && (
        <div className="flex flex-col gap-6">
          <AnalysisSubHeader
            title={t('analysisResult.competitiveLandscapeAndMarketGrowth.marketGrowth')}
            subtitle={t('analysisResult.competitiveLandscapeAndMarketGrowth.yearOverYearTrends')}
          />
          {yoyTrends && <TwoColumnProse text={yoyTrends} />}
          {marketGrowthDatasets?.map((cited) => (
            <StatistaChartCard key={cited.id} dataset={cited} citedIn={yoyTrends} />
          ))}
        </div>
      )}
    </div>
  );
};
